import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Nav, Navbar } from 'react-bootstrap';
import { Theme } from '../theme';
import { SchoolYear } from '../types';
import { Icon, IconName } from './icons';
import ThemeToggle from './ThemeToggle';

const NAV_ITEMS: { to: string; label: string; icon: IconName }[] = [
    { to: '/summary', label: 'Podsumowanie', icon: 'summary' },
    { to: '/spendings', label: 'Wydatki', icon: 'wallet' },
    { to: '/school-year-summary', label: 'Podsumowanie roczne', icon: 'calendar' },
    { to: '/visibility-manager', label: 'Zarządzaj osobami', icon: 'users' },
    { to: '/events-manager', label: 'Wydarzenia', icon: 'ticket' },
    { to: '/history', label: 'Historia transakcji', icon: 'list' },
];

const Header: React.FC<{
    onLogout: () => void;
    onUploadClick: () => void;
    onPublicLinkClick: () => void;
    userName: string | null;
    schoolYears: SchoolYear[];
    selectedSchoolYear: SchoolYear | null;
    handleSchoolYearChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    lastUploadTimestamp: string | null;
    formatTimestamp: (timestamp: string) => string;
    theme: Theme;
    onToggleTheme: () => void;
}> = ({ onLogout, onUploadClick, onPublicLinkClick, userName, schoolYears, selectedSchoolYear, handleSchoolYearChange, lastUploadTimestamp, formatTimestamp, theme, onToggleTheme }) => {
    // Logged out: no navigation, only the theme switch floating in the corner.
    if (!userName) {
        return (
            <div className="auth-topbar">
                <ThemeToggle theme={theme} onToggle={onToggleTheme} />
            </div>
        );
    }

    return (
        <Navbar expand="lg" fixed="top" className="app-nav" collapseOnSelect>
            <div className="container-fluid">
                <Navbar.Brand as={Link} to="/">
                    <span className="brand-mark" aria-hidden="true">S</span>
                    Skarbnik
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="app-nav-menu" label="Otwórz menu" />
                <Navbar.Collapse id="app-nav-menu">
                    {lastUploadTimestamp && (
                        <div className="nav-meta">
                            <span>Ostatnia aktualizacja</span>
                            <time dateTime={lastUploadTimestamp}>{formatTimestamp(lastUploadTimestamp)}</time>
                        </div>
                    )}

                    <Nav as="nav" aria-label="Główna nawigacja">
                        {NAV_ITEMS.map(item => (
                            <Nav.Link key={item.to} as={NavLink} to={item.to} eventKey={item.to}>
                                <Icon name={item.icon} />
                                {item.label}
                            </Nav.Link>
                        ))}
                    </Nav>

                    <div className="nav-footer">
                        <button type="button" className="btn btn-primary w-100" onClick={onUploadClick}>
                            <Icon name="upload" />
                            Wgraj transakcje
                        </button>

                        <div className="nav-field">
                            <label htmlFor="schoolYearSelector">Rok szkolny</label>
                            <select
                                id="schoolYearSelector"
                                className="form-select form-select-sm"
                                value={selectedSchoolYear?.name || ''}
                                onChange={handleSchoolYearChange}
                            >
                                {schoolYears.map(year => (
                                    <option key={year.id} value={year.name}>{year.name}</option>
                                ))}
                            </select>
                        </div>

                        <ThemeToggle theme={theme} onToggle={onToggleTheme} variant="row" />

                        <div className="user-card">
                            <div className="user-id">
                                <span className="user-avatar" aria-hidden="true">{userName.trim().charAt(0).toUpperCase()}</span>
                                <span className="user-name" title={userName}>{userName}</span>
                            </div>
                            <div className="user-actions">
                                <button type="button" className="ghost-btn" onClick={onPublicLinkClick}>
                                    <Icon name="link" size={16} />
                                    Link publiczny
                                </button>
                                <button type="button" className="ghost-btn" onClick={onLogout}>
                                    <Icon name="logout" size={16} />
                                    Wyloguj
                                </button>
                            </div>
                        </div>
                    </div>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
};

export default Header;
